import { Box, Card, Chip, Grid, styled, useTheme } from '@mui/material'
import S3Image from 'Components/S3Image'
import { type ServiceLog } from 'core/types'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'

const StyledCard = styled(Card)`
  border: 1px solid rgba(231, 231, 231, 1);
  border-radius:10px;
  width:100%;
  .LayoutGrid {
    display: flex;
    flex-direction:row;
    justify-content: space-between;
    margin:10px 5px;
    .MuiGrid-item {
      display:flex;
      align-items:center;
    }
  }
`

export function ServiceLogCard (props: ServiceLog): JSX.Element {
  const theme = useTheme()

  return <StyledCard>

    <Grid className='LayoutGrid'>
      <Grid item width={'25%'} sx={{
        justifyContent: 'center'
      }}
      >
        {props.s3Key != null
          ? (
            <S3Image style={{
              width: '50px',
              height: '50px'
            }}
              imageKey={props.s3Key}
            />
            )
          : <InsertDriveFileOutlinedIcon sx={{ height: '50px', width: '50px', color: 'purple' }}/>
      }
      </Grid>
      <Grid item sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'flex-start !important',
        gap: 1,
        justifyContent: 'space-between'
      }}
      >
        <Box sx={{ alignSelf: 'center' }}>
          {props.serviceName}
        </Box>
        <Box sx={{ alignSelf: 'center' }}>
          <Chip icon={<FiberManualRecordIcon color='primary' />}
            sx={{
              backgroundColor: theme.palette.primary.light,
              color: theme.palette.primary.main
            }}
            label={props.status}
          />
        </Box>
      </Grid>
    </Grid>
  </StyledCard>
}
